import React, { useState, useEffect } from "react";
import Modal from "../../modal";
import { getAreas } from "../../../services/areas";
import { ErrorContext } from "../../../utils/context/error";
import { getUsuarioFind } from "../../../services/user";
import { getServicioAllxArea } from "../../../services/servicios";

function FilterModal({ show, setShowM, AreaI, realizarConsulta }) 
{
  const [areas, setAreas] = useState([]);
  const [Servicios, setServicios] = useState([]);
  const [years, setYears] = useState([]);
  const [data, setData] = useState([]);
  const [areaId, setAreaId] = useState(0);
  const [shows, setShow] = useState(show);
  const [mes, setMes] = useState(0);
  const [anio, setAnio] = useState(0);
  const [servicioId, setServicio] = useState(0);
  const [usuarioId, setUsuarioId] = useState(0);
  const [nombreusr, setNombreUsr] = useState("");
  const [codigousr, setCodigoUsr] = useState("");
  const [activa, setActiva]= useState(false);
  const { setShowToast, setOpciones } = ErrorContext();
  const [habilita, setHabilita] = useState(false); 
  let timeout="";
  
  //-----------------------------------------------------
  useEffect(() => 
    {
      fillSelectServicios(areaId)
     }, [areaId]);

  //-----------------------------------------------------
  const handleCancel = async () => {
    setShowM(false);
  };

  //-----------------------------------------------------
  const handleAceptar = () => 
    {
      realizarConsulta(areaId, mes, anio, servicioId, usuarioId, nombreusr);
      setShow(false);
      setShowM(false);
    };
  
  //-----------------------------------------------------
  const fillSelectServicios = async (AreaId) => 
    {
      const response = await getServicioAllxArea(AreaId);
      if (response) 
        {
           if (response.status === 200) 
            {
               setServicios(response.data.data);
            } 
           else 
           {
             const Mensaje = response.message;
             const opc = { type: "Danger", message: Mensaje, active: true };
             setOpciones(opc);
             setShowToast(true);
           }
        }
    };

  //-----------------------------------------------------
  const handleUsuario = async (query)=>
    {
      if (query.length > 2)
       {
         if (timeout) clearTimeout(timeout);
           timeout = setTimeout(function()
             {
                Procesar(query);
                clearTimeout(timeout);
              },1000);
      }
    }
  
  //-----------------------------------------------------
  const Procesar= async (query)=>
    {
      setActiva(true);
      const response = await getUsuarioFind(query);
      if (response)
       {
         if (response.status === 200) 
          {
            setData(response.data.data);
            setActiva(false);
          } 
         else 
         {
            const Mensaje = response.message;
            const opc = { type: "Danger", message: Mensaje, active: true };
            setOpciones(opc);
            setShowToast(true);
         }  
       }
    }
  
  //-----------------------------------------------------
   const handlefilas=(item)=>
    {
      setNombreUsr(item.NombreUsr);
      setUsuarioId(item.UsuarioId);
      setCodigoUsr(item.CodigoUsr);
      setData([]);
    }  
 //------------------------------------------------------  
  useEffect(() => 
    {
     setMes(new Date().getMonth()+1);
     setAnio(new Date().getFullYear());
    
     const fillSelectAreas = async () => 
      {
       setYears(range((new Date().getFullYear()-3), (new Date().getFullYear()+ 1)));
    
       const response = await getAreas();
       if (response) 
        {
          if (response.status === 200) 
            {
              setAreas(response.data.data);
            } 
          else 
          {
            const Mensaje = response.message;
            const opc = { type: "Danger", message: Mensaje, active: true };
            setOpciones(opc);
            setShowToast(true);
          }
        }
      setAreaId(AreaI);
      if (AreaI >0)
        fillSelectServicios(AreaI);    
    };
    fillSelectAreas();
   }, []);
  
  //-----------------------------------------------------
  const range = (min, max)=>
    {
      let result=[];  
      for (let i = min; i <= max; i++) 
        {
          result.push(i)
        }
      return result;  
    }

  return (
    <>
      <Modal isOpen={show} onClose={()=>setShowM(false)} title={'Buscar'}>
        <div className="flex lg:w-[25rem]">
          <form noValidate className="flex flex-col w-full">
            <div className="flex flex-col w-full h-full ">
              <div className="w-full">
                <label>Area</label>
                <select id="area" name="area" value={areaId || 0} onChange={(e) => setAreaId(e.target.value)} label="Area">
                  <option value={0} disabled>
                    Seleccionar una Area...
                  </option>
                    {areas.map((item) => {
                      return (
                        <option key={item.AreaId} value={item.AreaId}>
                          {item.NombreArea}
                        </option>
                      );
                    })}
                </select>
              </div>
              <div className="w-full mt-4">
                 <label>Servicio</label>
                 <select id="area" name="area" value={servicioId || 0} onChange={(e) => setServicio(e.target.value)} label="servicio" >
                    <option value={0} disabled>
                        Seleccionar un Servicio...
                    </option>
                    {Servicios.map((item) => {
                      return (
                        <option key={`${item.AreaId}${item.ServicioId}`} value={item.ServicioId}>
                            {item.NombreServ}
                        </option>
                      );
                    })}
                 </select>                  
              </div> 
              <div className="w-full mt-4">
                <label>Nombre o Identificación del Usuario</label>
                <input type="text" name='searchid' value={nombreusr || ""} placeholder="Buscar Usuarios..." 
                    onKeyUp={(e) => handleUsuario(e.target.value.toUpperCase())}
                    onChange={(e)=> setNombreUsr(e.target.value)}
                    autoComplete="off" 
                    disabled={activa}
                />
                <div className={ data.length >0 ? "block" : "hidden"}>
                  <table className="absolute z-10  bg-white border border-gray-300 rounded shadow-lg mt-1">
                    <thead className="border-b border-stone-200 text-sm font-medium ">
                      <tr>
                        <th className="px-2.5 py-2 text-start font-medium">Documento</th>
                        <th className="px-2.5 py-2 text-start font-medium">Nombre</th>
                        <th className="px-2.5 py-2 text-start font-medium">Cargo</th>
                      </tr>
                    </thead>
                    <tbody className="group text-sm text-stone-800 ">
                      {data.map((item) => (
                        <tr className="border-b border-stone-200 last:border-0" key={item.UsuarioId}  onClick={() => handlefilas(item)}>
                          <td>{item.NumeroNit}</td>
                          <td>{item.NombreUsr}</td>
                          <td>{item.NombreCar}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>      
                </div>
             </div>
             <div className="flex w-full flex-row mt-4 gap-x-2">
               <div className="w-full">
                 <label>Mes</label>
                 <select id="mes" name="mes" value={mes || 0} onChange={(e) => setMes(e.target.value)} label="mes">
                   <option value={0} disabled>
                     Seleccionar un mes...
                   </option>
                   <option key={1} value={1}>
                     Enero
                   </option>
                   <option key={2} value={2}>
                     Febrero
                   </option>
                   <option key={3} value={3}>
                     Marzo
                   </option>
                   <option key={4} value={4}>
                     Abril
                   </option>
                   <option key={5} value={5}>
                     Mayo
                   </option>
                   <option key={6} value={6}>
                     Junio
                   </option>
                   <option key={7} value={7}>
                     Julio
                   </option>
                   <option key={8} value={8}>
                     Agosto
                   </option>
                   <option key={9} value={9}>
                     Septiembre
                   </option>
                   <option key={10} value={10}>
                     Octubre
                   </option>
                   <option key={11} value={11}>
                     Noviembre
                   </option>
                   <option key={12} value={12}>
                    Diciembre
                   </option>
                  </select>
                </div>
                <div className="w-full">
                  <label>Año</label>
                   <select id="area" name="area" value={anio || 0} onChange={(e) => setAnio(e.target.value)} label="anio">
                       <option value={0} disabled>
                           Seleccionar un Año...
                       </option>
                       {years.map((options) => {
                          return (
                              <option key={options} value={options}>
                                  {options}
                              </option>
                           )})};
                   </select>
                </div>
              </div>                        
            </div>
            <div className="flex w-full gap-4 mt-6 justify-end">
              <button name="Aceptar" className="btnprimary" onClick={handleAceptar} disabled={habilita} type="button">Aceptar</button>
              <button name="Cancelar" className="" onClick={handleCancel} disabled={habilita} type="button">Cancelar</button>
            </div> 
          </form>   
        </div>                                 
      </Modal>
    </>
  );
}
export default FilterModal;
